import React from 'react';
import PropTypes from 'prop-types';
import { NotificationCard } from './NotificationCard';
import { Overlay, NotificationStack } from './styles';

// Hardcoded stagger delays between stacked notification rows
const ANIMATION_DELAYS_MS = [350, 1100];

const getAnimationDelay = index =>
  ANIMATION_DELAYS_MS[index] ??
  ANIMATION_DELAYS_MS[ANIMATION_DELAYS_MS.length - 1] +
    (index - ANIMATION_DELAYS_MS.length + 1) * 750;

/**
 * Absolute overlay of notification rows for a parent image panel.
 *
 * Nested inside a tab panel so mount = animate in once, unmount = reset.
 * Re-clicks of the active tab keep the panel mounted, so no re-animation.
 *
 * Desktop: top-left or top-right via `alignment`.
 * Mobile: horizontally centered, vertically top-aligned.
 */
export const NotificationOverlay = ({
  alignment = 'right',
  notifications = [],
}) => {
  if (!notifications.length) {
    return null;
  }

  return (
    <Overlay aria-hidden="true">
      <NotificationStack $alignment={alignment}>
        {notifications.map((notification, index) => (
          <NotificationCard
            key={`${index}-${
              notification.subject || notification.message || ''
            }`}
            {...notification}
            delay={getAnimationDelay(index)}
          />
        ))}
      </NotificationStack>
    </Overlay>
  );
};

NotificationOverlay.displayName = 'NotificationOverlay';

NotificationOverlay.propTypes = {
  alignment: PropTypes.oneOf(['left', 'right']),
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        src: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
          .isRequired,
        alt: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      subject: PropTypes.string,
      subjectTypography: PropTypes.string,
      subjectFontColor: PropTypes.string,
      message: PropTypes.string,
      messageTypography: PropTypes.string,
      messageFontColor: PropTypes.string,
    }),
  ),
};

export { NotificationCard } from './NotificationCard';
